
import ApiService from '@/services/configs/api.service'

const ConfigurationService = {

  getInfo(){
   return ApiService.get('getPanneauDeConfiguration')
  },
  
  postInfo(params){
    return ApiService.post('admin/panneauDeConfiguration',params)
  }
 
 
};



export default ConfigurationService;
  